<script setup lang="ts">
import { useId } from 'vue';

const id = useId();
const wordmark = `${id}-wordmark`, emblem = `${id}-emblem`;
</script>

<template>
  <!-- Reuse the original transparent artwork: alpha preserves its exact lettering,
       while the emblem retains its original gradient. The old bottom rule is cropped. -->
  <svg class="enapres-logo" viewBox="60 0 2858 714" width="184" height="46" role="img" aria-label="ENAPRES" focusable="false">
    <defs>
      <mask :id="wordmark" x="0" y="0" width="1900" height="714" maskUnits="userSpaceOnUse" style="mask-type:alpha">
        <image href="/enapres-logo.png" width="2918" height="732"/>
      </mask>
      <clipPath :id="emblem"><rect x="1900" y="0" width="1018" height="714"/></clipPath>
    </defs>
    <rect x="0" y="0" width="1900" height="714" :mask="`url(#${wordmark})`" class="logo-wordmark"/>
    <image href="/enapres-logo.png" width="2918" height="732" :clip-path="`url(#${emblem})`"/>
  </svg>
</template>

<style scoped>
.enapres-logo{display:block;flex:none;height:auto;max-width:100%;aspect-ratio:2858/714;overflow:hidden}
.logo-wordmark{fill:var(--brand-wordmark)}
@media(forced-colors:active){.logo-wordmark{fill:CanvasText}}
</style>
